class CollectionInfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.isLoading = false;
  }

  connectedCallback() {
    this.spinner = this.querySelector('.collection-infinite-scroll__spinner');
    this.sentinel = this.querySelector('.collection-infinite-scroll__sentinel');
    this.paginationWrapper = this.parentElement?.querySelector('.pagination-wrapper');
    this.setupLoader();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  get nextUrl() {
    return this.dataset.nextUrl;
  }

  get productGrid() {
    return this.closest('#ProductGridContainer')?.querySelector('#product-grid');
  }

  setupLoader() {
    if (!this.nextUrl || !this.sentinel) return;

    if (this.paginationWrapper) this.paginationWrapper.hidden = true;
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);
    this.checkIfShouldLoad();
  }

  handleScroll() {
    this.checkIfShouldLoad();
  }

  handleResize() {
    this.checkIfShouldLoad();
  }

  checkIfShouldLoad() {
    if (this.isLoading || !this.nextUrl || !this.sentinel) return;

    const sentinelTop = this.sentinel.getBoundingClientRect().top;
    const threshold = window.innerHeight + 300;

    if (sentinelTop <= threshold) this.loadNextPage();
  }

  async loadNextPage() {
    if (this.isLoading || !this.nextUrl || !this.productGrid) return;

    this.isLoading = true;
    this.spinner?.classList.remove('hidden');

    try {
      const response = await fetch(this.nextUrl);
      if (!response.ok) throw new Error(`Failed to load products: ${response.status}`);

      const responseText = await response.text();
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const nextGrid = responseHTML.getElementById('product-grid');

      if (!nextGrid) throw new Error('Product grid not found in response.');

      Array.from(nextGrid.children).forEach((item) => {
        this.productGrid.appendChild(item);
      });

      const currentPagination = this.parentElement?.querySelector('.pagination-wrapper');
      const nextPagination = responseHTML.querySelector('#ProductGridContainer .pagination-wrapper');

      if (currentPagination) {
        if (nextPagination) {
          currentPagination.replaceWith(nextPagination);
        } else {
          currentPagination.remove();
        }
      }

      const nextInfiniteScroll = responseHTML.querySelector('#ProductGridContainer collection-infinite-scroll');

      if (nextInfiniteScroll?.dataset.nextUrl) {
        this.dataset.nextUrl = nextInfiniteScroll.dataset.nextUrl;
        this.paginationWrapper = this.parentElement?.querySelector('.pagination-wrapper');
        this.setupLoader();
      } else {
        if (this.parentElement?.querySelector('.pagination-wrapper')) {
          this.parentElement.querySelector('.pagination-wrapper').hidden = false;
        }
        this.remove();
      }

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(this.productGrid);
      }
    } catch (error) {
      console.error('Infinite scroll failed to load more products.', error);
      if (this.paginationWrapper) this.paginationWrapper.hidden = false;
      this.remove();
    } finally {
      this.isLoading = false;
      this.spinner?.classList.add('hidden');
    }
  }
}

if (!customElements.get('collection-infinite-scroll')) {
  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
